export const WARDS = ['All Wards', 'ICU', 'Medical', 'Surgical', 'Pediatrics', 'Maternity'];

export const MOCK_PATIENTS = [
  {
    id: 'p1',
    name: 'عمر خليل',
    nameEn: 'Omar Khalil',
    room: '5',
    ward: 'Medical',
    wardType: 'medical',
    age: 67,
    sex: 'Male',
    favorite: true,
    documented: false,
    allergies: ['Penicillin — CRITICAL', 'Aspirin'],
    diagnoses: ['Type 2 Diabetes', 'Hypertension'],
    medications: [
      { name: 'Metformin', dose: '500mg', route: 'PO', frequency: 'BID' },
      { name: 'Amlodipine', dose: '5mg', route: 'PO', frequency: 'OD' },
    ],
    recentVitals: { bp: '130/82', pulse: '76', temp: '36.8', o2: '97%', date: '2026-07-06' },
    lastNote: null,
    tasks: [
      { id: 't1', type: 'vitals', label: 'Morning vitals', noteType: 'vitals', time: '08:00', completed: false },
      { id: 't2', type: 'progress_note', label: 'Progress note', noteType: 'progress_note', time: '10:00', completed: false },
    ],
  },
  {
    id: 'p2',
    name: 'فاطمة أحمد',
    nameEn: 'Fatima Ahmad',
    room: '12',
    ward: 'Surgical',
    wardType: 'surgical',
    age: 45,
    sex: 'Female',
    favorite: false,
    documented: true,
    allergies: ['NKDA'],
    diagnoses: ['Post-op cholecystectomy'],
    medications: [{ name: 'Paracetamol', dose: '500mg', route: 'PO', frequency: 'Q6H PRN' }],
    recentVitals: { bp: '118/74', pulse: '72', temp: '37.1', o2: '98%', date: '2026-07-06' },
    lastNote: { nurse: 'Sarah Al-Hassan', excerpt: 'Patient stable post-op, ambulating with assistance.', date: '2026-07-05' },
    tasks: [
      { id: 't3', type: 'handover', label: 'Shift handover', noteType: 'handover', time: '14:00', completed: true },
    ],
  },
  {
    id: 'p3',
    name: 'خالد منصور',
    nameEn: 'Khalid Mansour',
    room: '8',
    ward: 'ICU',
    wardType: 'icu',
    age: 58,
    sex: 'Male',
    favorite: true,
    documented: false,
    allergies: ['Sulfa drugs'],
    diagnoses: ['COPD exacerbation', 'Pneumonia'],
    medications: [
      { name: 'Salbutamol nebulizer', dose: '2.5mg', route: 'Nebulized', frequency: 'Q4H' },
      { name: 'Ceftriaxone', dose: '500mg', route: 'IV', frequency: 'OD' },
    ],
    recentVitals: { bp: '142/88', pulse: '92', temp: '38.2', o2: '91%', date: '2026-07-06' },
    lastNote: null,
    tasks: [
      { id: 't4', type: 'vitals', label: 'Hourly vitals', noteType: 'vitals', time: '09:00', completed: false },
      { id: 't5', type: 'mar', label: 'Medication administration', noteType: 'medication_admin', time: '09:30', completed: false },
    ],
  },
  {
    id: 'p4',
    name: 'ليلى يوسف',
    nameEn: 'Layla Yousef',
    room: '3',
    ward: 'Maternity',
    wardType: 'maternity',
    age: 28,
    sex: 'Female',
    favorite: false,
    documented: false,
    allergies: [],
    diagnoses: ['Normal spontaneous delivery'],
    medications: [{ name: 'Iron supplement', dose: '325mg', route: 'PO', frequency: 'OD' }],
    recentVitals: { bp: '110/70', pulse: '80', temp: '36.9', o2: '99%', date: '2026-07-06' },
    lastNote: null,
    tasks: [],
  },
  {
    id: 'p5',
    name: 'محمود الزعبي',
    nameEn: 'Mahmoud Al-Zoubi',
    room: '15',
    ward: 'Medical',
    wardType: 'medical',
    age: 72,
    sex: 'Male',
    favorite: false,
    documented: true,
    allergies: ['Latex'],
    diagnoses: ['Atrial fibrillation', 'CHF'],
    medications: [
      { name: 'Warfarin', dose: '5mg', route: 'PO', frequency: 'OD' },
      { name: 'Furosemide', dose: '40mg', route: 'PO', frequency: 'OD' },
    ],
    recentVitals: { bp: '128/78', pulse: '68', temp: '36.6', o2: '96%', date: '2026-07-06' },
    lastNote: { nurse: 'Sarah Al-Hassan', excerpt: 'No new complaints. Weight stable.', date: '2026-07-05' },
    tasks: [],
  },
  {
    id: 'p6',
    name: 'نور الدين',
    nameEn: 'Nour Al-Deen',
    room: '21',
    ward: 'Pediatrics',
    wardType: 'pediatrics',
    age: 8,
    sex: 'Male',
    favorite: false,
    documented: false,
    allergies: ['Peanuts — CRITICAL'],
    diagnoses: ['Asthma'],
    medications: [{ name: 'Budesonide inhaler', dose: '100mcg', route: 'Nebulized', frequency: 'BID' }],
    recentVitals: { bp: '95/60', pulse: '88', temp: '37.0', o2: '98%', date: '2026-07-06' },
    lastNote: null,
    tasks: [],
  },
  {
    id: 'p7',
    name: 'ريم حداد',
    nameEn: 'Reem Haddad',
    room: '9',
    ward: 'Surgical',
    wardType: 'surgical',
    age: 34,
    sex: 'Female',
    favorite: true,
    documented: false,
    allergies: ['NKDA'],
    diagnoses: ['Appendicitis post-op'],
    medications: [{ name: 'Cefazolin', dose: '500mg', route: 'IV', frequency: 'Q8H' }],
    recentVitals: { bp: '122/76', pulse: '74', temp: '37.3', o2: '97%', date: '2026-07-06' },
    lastNote: null,
    tasks: [],
  },
  {
    id: 'p8',
    name: 'ياسر عبيد',
    nameEn: 'Yaser Obeid',
    room: '18',
    ward: 'Medical',
    wardType: 'medical',
    age: 55,
    sex: 'Male',
    favorite: false,
    documented: false,
    allergies: ['Codeine'],
    diagnoses: ['CKD Stage 3', 'Anemia'],
    medications: [{ name: 'Epoetin alfa', dose: '4000 units', route: 'SC', frequency: 'Weekly' }],
    recentVitals: { bp: '148/90', pulse: '78', temp: '36.7', o2: '95%', date: '2026-07-06' },
    lastNote: null,
    tasks: [],
  },
];

export function getPatientById(id, admittedPatients = []) {
  return [...MOCK_PATIENTS, ...admittedPatients].find((p) => p.id === id) || null;
}

export function getAllPatients(admittedPatients = []) {
  return [...MOCK_PATIENTS, ...admittedPatients];
}

export function getPatientDisplayName(patient, language = 'en') {
  if (!patient) return language === 'ar' ? 'مريض غير معروف' : 'Unknown Patient';
  if (language === 'ar') return patient.name || patient.nameEn;
  return patient.nameEn || patient.name;
}

export function getNotePatientDisplayName(note, admittedPatients = [], language = 'en') {
  const patient = note?.patient_id ? getPatientById(note.patient_id, admittedPatients) : null;
  if (patient) return getPatientDisplayName(patient, language);
  return note?.patient_name || (language === 'ar' ? 'مريض غير معروف' : 'Unknown Patient');
}
